<li class="language-selection-item-container" [class.indented]="indented" [class.selected]="selected" (click)="languageSelected.emit(language);"
    cpClickableElement elementRole="menuitemradio" [attr.aria-checked]="selected">
  {{language.patientDescription || language.language}}
</li>
